import { Grid, Typography } from "@pankod/refine-mui";

export default function Privacy() {
  return (
    <Grid container padding={2}>
      <Typography>Pryvacy Policy</Typography>
    </Grid>
  );
}
